import pilsenImg from '../assets/pilsen.png';
import cusquenaImg from '../assets/cusqueña.jpg';
import pacificoImg from '../assets/pacifico.png';
import coronaImg from '../assets/corona.jpg';
import choritosChalacaImg from '../assets/choritosalachalaca.jpg';
import mostritoTripleImg from '../assets/mostritotriple.jpg';
import cevichopsCategoryImg from '../assets/cevichops.jpg';
import cevicheDeAbueloImg from '../assets/cevichedeabuelo.jpg';
import parihuelaImg from '../assets/parihuela.jpg';
import arrozDeMariscosImg from '../assets/arrozdemariscos.jpg';
import piscoSourImg from '../assets/piscosour.jpg';
import mojitosImg from '../assets/mojitos.jpg';
import togarashiImg from '../assets/toragashi.jpg';
import chicharronDeChanchoImg from '../assets/chicharrondechancho.jpg';

export interface Product {
  id: string;
  name: string;
  description: string;
  price: number;
  image: string;
  category: string;
  ingredients: string[];
  spicyLevel?: 'mild' | 'medium' | 'hot';
  popular?: boolean;
  sizes?: {
    name: string;
    price: number;
  }[];
  options?: {
    name: string;
    choices: {
      name: string;
      price: number;
    }[];
  }[];
}

export interface Category {
  id: string;
  name: string;
  icon: string;
  description: string;
}

const publicUrl = process.env.PUBLIC_URL || '';
const asset = (file: string) => `${publicUrl}/${file}`;

export const categories: Category[] = [
  {
    id: 'entradas',
    name: 'Entradas',
    icon: 'fas fa-utensils',
    description: 'Para comenzar con sabor'
  },
  {
    id: 'combinados-barrio',
    name: 'Combinados “De Barrio”',
    icon: 'fas fa-plate-wheat',
    description: 'Incluyen ceviche y acompañamientos según cada opción'
  },
  {
    id: 'arroces',
    name: 'Arroces',
    icon: 'fas fa-bowl-rice',
    description: 'Arroces y chaufas'
  },
  {
    id: 'cevichops',
    name: 'Cevichops',
    icon: 'fas fa-wine-glass',
    description: 'Sabores: clásico, rocoto, ají, aceituna, palta'
  },
  {
    id: 'barra-cevichera',
    name: 'Cevichera – Barra',
    icon: 'fas fa-lemon',
    description: 'Ceviches, causas y makis'
  },
  {
    id: 'chicharrones',
    name: 'Chicharrones',
    icon: 'fas fa-fire',
    description: 'Pescado y mariscos crocantes'
  },
  {
    id: 'alguito-mas',
    name: 'Alguito Más',
    icon: 'fas fa-plus-circle',
    description: 'Platos adicionales'
  },
  {
    id: 'promociones',
    name: 'Promociones (9:30 a 12:00 p.m.)',
    icon: 'fas fa-tags',
    description: 'Incluyen vaso de chicha o maracuyá + queso helado'
  },
  {
    id: 'porciones',
    name: 'Porciones',
    icon: 'fas fa-cookie-bite',
    description: 'Acompañamientos'
  },
  {
    id: 'postres',
    name: 'Postres',
    icon: 'fas fa-ice-cream',
    description: 'Dulce final'
  },
  {
    id: 'bebidas',
    name: 'Bebidas (½ Lt / 1 Lt)',
    icon: 'fas fa-glass-water',
    description: 'Refrescantes bebidas'
  },
  {
    id: 'cervezas',
    name: 'Cervezas',
    icon: 'fas fa-beer',
    description: 'Clásicas y bien heladas'
  },
  {
    id: 'cocteles',
    name: 'Cócteles',
    icon: 'fas fa-cocktail',
    description: 'Sours, mojitos y más'
  }
];

export const products: Product[] = [
  // ENTRADAS
  {
    id: 'tequenos-saltado-pescado',
    name: 'Tequeños rellenos con saltado de pescado',
    description: 'Tequeños crocantes rellenos con pescado salteado.',
    price: 15.00,
    image: asset('chop.jpeg'),
    category: 'entradas',
    ingredients: ['Tequeños', 'Pescado']
  },
  {
    id: 'tequenos-queso-andino',
    name: 'Tequeños rellenos con queso andino',
    description: 'Tequeños fritos rellenos de queso andino.',
    price: 15.00,
    image: asset('chop.jpeg'),
    category: 'entradas',
    ingredients: ['Tequeños', 'Queso andino']
  },
  {
    id: 'choritos-chalaca',
    name: 'Choritos a la chalaca',
    description: 'Mejillones con salsa criolla (cebolla, tomate, limón).',
    price: 18.00,
    image: choritosChalacaImg,
    category: 'entradas',
    ingredients: ['Choritos', 'Cebolla', 'Tomate', 'Limón']
  },
  {
    id: 'chilcanito',
    name: 'Chilcanito',
    description: 'Bebida refrescante a base de limón.',
    price: 7.00,
    image: asset('ceviche.jpg'),
    category: 'entradas',
    ingredients: ['Limón', 'Hielo']
  },

  // COMBINADOS “DE BARRIO”
  {
    id: 'mostrito-doble',
    name: 'Mostrito Doble',
    description: 'Ceviche + arroz de mariscos o chaufa.',
    price: 28.00,
    image: asset('mixto.jpg'),
    category: 'combinados-barrio',
    ingredients: ['Ceviche', 'Arroz']
  },
  {
    id: 'mostrito-triple',
    name: 'Mostrito Triple',
    description: 'Ceviche + arroz de mariscos/chaufa + chicharrón.',
    price: 38.00,
    image: mostritoTripleImg,
    category: 'combinados-barrio',
    ingredients: ['Ceviche', 'Arroz', 'Chicharrón']
  },
  {
    id: 'clandestino',
    name: 'Clandestino',
    description: 'Ceviche con chicharrón de pescado.',
    price: 32.00,
    image: asset('chop.jpeg'),
    category: 'combinados-barrio',
    ingredients: ['Ceviche', 'Chicharrón de pescado']
  },
  {
    id: 'don-beto',
    name: 'Don Beto',
    description: 'Ceviche con chicharrón mixto.',
    price: 33.00,
    image: asset('mixto.jpg'),
    category: 'combinados-barrio',
    ingredients: ['Ceviche', 'Chicharrón mixto']
  },
  {
    id: 'pichangero',
    name: 'Pichangero',
    description: 'Causa + ceviche + arroz + chicharrón de pota.',
    price: 45.00,
    image: asset('mixto.jpg'),
    category: 'combinados-barrio',
    ingredients: ['Causa', 'Ceviche', 'Arroz', 'Chicharrón de pota']
  },
  {
    id: 'achorado',
    name: 'Achorado',
    description: 'Ceviche en crema + pulpo al olivo + arroz + chicharrón de pota + papa a la huancaína.',
    price: 58.00,
    image: asset('mixto.jpg'),
    category: 'combinados-barrio',
    ingredients: ['Ceviche en crema', 'Pulpo', 'Arroz', 'Chicharrón de pota', 'Papa a la huancaína']
  },
  {
    id: 'arrechito',
    name: 'Arrechito',
    description: 'Papa a la huancaína + ceviche + arroz.',
    price: 36.00,
    image: asset('mixto.jpg'),
    category: 'combinados-barrio',
    ingredients: ['Papa a la huancaína', 'Ceviche', 'Arroz']
  },
  {
    id: 'pepeadora',
    name: 'Pepeadora',
    description: 'Leche de tigre + arroz + causa + chicharrón de pota.',
    price: 45.00,
    image: asset('mixto.jpg'),
    category: 'combinados-barrio',
    ingredients: ['Leche de tigre', 'Arroz', 'Causa', 'Chicharrón de pota']
  },
  {
    id: 'gloton',
    name: 'Glotón',
    description: 'Ceviche + arroz + chicharrón + choritos + yuquitas.',
    price: 50.00,
    image: asset('mixto.jpg'),
    category: 'combinados-barrio',
    ingredients: ['Ceviche', 'Arroz', 'Chicharrón', 'Choritos', 'Yuca']
  },

  // ARROCES
  {
    id: 'arroz-mariscos',
    name: 'Arroz con mariscos',
    description: 'Arroz con mariscos.',
    price: 28.00,
    image: arrozDeMariscosImg,
    category: 'arroces',
    ingredients: ['Arroz', 'Mariscos']
  },
  {
    id: 'chaufa-mariscos',
    name: 'Arroz chaufa de mariscos',
    description: 'Arroz chaufa de mariscos.',
    price: 28.00,
    image: asset('arroz.jpg'),
    category: 'arroces',
    ingredients: ['Arroz', 'Mariscos']
  },
  {
    id: 'chaufa-pescado',
    name: 'Arroz chaufa de pescado',
    description: 'Arroz chaufa de pescado.',
    price: 26.00,
    image: asset('arroz.jpg'),
    category: 'arroces',
    ingredients: ['Arroz', 'Pescado']
  },

  // CEVICHOPS
  {
    id: 'cevichop-pota',
    name: 'Cevichop con chicharrón de pota',
    description: 'Cevichop con chicharrón de pota. Sabores: clásico, rocoto, ají, aceituna, palta.',
    price: 18.00,
    image: cevichopsCategoryImg,
    category: 'cevichops',
    ingredients: ['Ceviche', 'Chicharrón de pota'],
    options: [
      {
        name: 'Sabor',
        choices: [
          { name: 'Clásico', price: 0 },
          { name: 'Rocoto', price: 0 },
          { name: 'Ají', price: 0 },
          { name: 'Aceituna', price: 0 },
          { name: 'Palta', price: 0 }
        ]
      }
    ]
  },
  {
    id: 'cevichop-pescado',
    name: 'Cevichop con chicharrón de pescado',
    description: 'Cevichop con chicharrón de pescado. Sabores: clásico, rocoto, ají, aceituna, palta.',
    price: 20.00,
    image: cevichopsCategoryImg,
    category: 'cevichops',
    ingredients: ['Ceviche', 'Chicharrón de pescado'],
    options: [
      {
        name: 'Sabor',
        choices: [
          { name: 'Clásico', price: 0 },
          { name: 'Rocoto', price: 0 },
          { name: 'Ají', price: 0 },
          { name: 'Aceituna', price: 0 },
          { name: 'Palta', price: 0 }
        ]
      }
    ]
  },
  {
    id: 'leche-tigre-carinosa',
    name: 'Leche de tigre “Cariñosa”',
    description: 'Leche de tigre.',
    price: 15.00,
    image: cevichopsCategoryImg,
    category: 'cevichops',
    ingredients: ['Leche de tigre']
  },
  {
    id: 'leche-tigre-lujuriosa',
    name: 'Leche de tigre “Lujuriosa”',
    description: 'Leche de tigre.',
    price: 15.00,
    image: cevichopsCategoryImg,
    category: 'cevichops',
    ingredients: ['Leche de tigre']
  },

  // CEVICHERA – BARRA
  {
    id: 'causa-acevichada',
    name: 'Causa acevichada',
    description: 'Causa acevichada.',
    price: 30.00,
    image: asset('ceviche.jpg'),
    category: 'barra-cevichera',
    ingredients: ['Causa', 'Ceviche']
  },
  {
    id: 'maki-acevichado',
    name: 'Maki acevichado',
    description: 'Maki acevichado.',
    price: 22.00,
    image: asset('ceviche.jpg'),
    category: 'barra-cevichera',
    ingredients: ['Maki', 'Ceviche']
  },
  {
    id: 'ceviche-abuelo',
    name: 'Ceviche de Abuelo',
    description: 'Pescado al limón.',
    price: 25.00,
    image: cevicheDeAbueloImg,
    category: 'barra-cevichera',
    ingredients: ['Pescado', 'Limón']
  },
  {
    id: 'ceviche-casa',
    name: 'Ceviche clásico de la casa',
    description: 'Ceviche clásico.',
    price: 25.00,
    image: asset('ceviche.jpg'),
    category: 'barra-cevichera',
    ingredients: ['Pescado', 'Limón']
  },
  {
    id: 'ceviche-power',
    name: 'Ceviche Power',
    description: 'Pescado + mariscos.',
    price: 28.00,
    image: asset('mixto.jpg'),
    category: 'barra-cevichera',
    ingredients: ['Pescado', 'Mariscos']
  },
  {
    id: 'ceviche-pirata',
    name: 'Ceviche del Pirata',
    description: 'Puro mariscos.',
    price: 28.00,
    image: asset('mixto.jpg'),
    category: 'barra-cevichera',
    ingredients: ['Mariscos']
  },
  {
    id: 'ceviche-cura-todo',
    name: 'Ceviche Cura Todo',
    description: 'Ceviche Cura Todo.',
    price: 30.00,
    image: asset('mixto.jpg'),
    category: 'barra-cevichera',
    ingredients: ['Pescado', 'Limón']
  },
  {
    id: 'ceviche-crema-rocoto',
    name: 'Ceviche en crema de rocoto',
    description: 'Ceviche en crema de rocoto.',
    price: 27.00,
    image: asset('ceviche.jpg'),
    category: 'barra-cevichera',
    ingredients: ['Pescado', 'Rocoto']
  },
  {
    id: 'ceviche-crema-aji-amarillo',
    name: 'Ceviche en crema de ají amarillo',
    description: 'Ceviche en crema de ají amarillo.',
    price: 27.00,
    image: asset('ceviche.jpg'),
    category: 'barra-cevichera',
    ingredients: ['Pescado', 'Ají amarillo']
  },
  {
    id: 'ceviche-crema-aceituna',
    name: 'Ceviche con crema de aceituna',
    description: 'Ceviche con crema de aceituna.',
    price: 27.00,
    image: asset('ceviche.jpg'),
    category: 'barra-cevichera',
    ingredients: ['Pescado', 'Aceituna']
  },
  {
    id: 'ceviche-palteado',
    name: 'Ceviche palteado',
    description: 'Ceviche palteado.',
    price: 27.00,
    image: asset('ceviche.jpg'),
    category: 'barra-cevichera',
    ingredients: ['Pescado', 'Palta']
  },
  {
    id: 'ceviche-crema-mediterranea',
    name: 'Ceviche en crema mediterránea',
    description: 'Ceviche en crema mediterránea.',
    price: 27.00,
    image: asset('ceviche.jpg'),
    category: 'barra-cevichera',
    ingredients: ['Pescado', 'Crema']
  },
  {
    id: 'ceviche-tricolor',
    name: 'Ceviche tricolor',
    description: 'Elige 3 sabores.',
    price: 36.00,
    image: asset('mixto.jpg'),
    category: 'barra-cevichera',
    ingredients: ['Pescado', 'Salsas']
  },

  // CHICHARRONES
  {
    id: 'chicharron-pescado',
    name: 'Chicharrón de pescado',
    description: 'Chicharrón de pescado.',
    price: 30.00,
    image: asset('mixto.jpg'),
    category: 'chicharrones',
    ingredients: ['Pescado']
  },
  {
    id: 'chicharron-mariscos',
    name: 'Chicharrón de mariscos',
    description: 'Chicharrón de mariscos.',
    price: 35.00,
    image: asset('mixto.jpg'),
    category: 'chicharrones',
    ingredients: ['Mariscos']
  },
  {
    id: 'chicharron-mixto',
    name: 'Chicharrón mixto',
    description: 'Chicharrón mixto.',
    price: 28.00,
    image: asset('mixto.jpg'),
    category: 'chicharrones',
    ingredients: ['Pescado', 'Mariscos']
  },
  {
    id: 'pescado-frito-entero',
    name: 'Pescado frito entero',
    description: 'Pescado frito entero.',
    price: 30.00,
    image: asset('mixto.jpg'),
    category: 'chicharrones',
    ingredients: ['Pescado']
  },

  // ALGUITO MÁS
  {
    id: 'parihuela',
    name: 'Parihuela',
    description: 'Parihuela.',
    price: 27.00,
    image: parihuelaImg,
    category: 'alguito-mas',
    ingredients: ['Mariscos', 'Caldo']
  },
  {
    id: 'sudado-pescado',
    name: 'Sudado de pescado',
    description: 'Sudado de pescado.',
    price: 20.00,
    image: asset('ceviche.jpg'),
    category: 'alguito-mas',
    ingredients: ['Pescado']
  },
  {
    id: 'lomo-saltado',
    name: 'Lomo saltado',
    description: 'Lomo saltado.',
    price: 35.00,
    image: asset('arroz.jpg'),
    category: 'alguito-mas',
    ingredients: ['Carne', 'Papas']
  },
  {
    id: 'alitas-bbq',
    name: 'Alitas BBQ',
    description: 'Alitas BBQ.',
    price: 30.00,
    image: asset('mixto.jpg'),
    category: 'alguito-mas',
    ingredients: ['Alitas', 'BBQ']
  },
  {
    id: 'chicharron-chancho',
    name: 'Chicharrón de chancho',
    description: 'Chicharrón de chancho.',
    price: 0.00,
    image: chicharronDeChanchoImg,
    category: 'alguito-mas',
    ingredients: ['Chancho']
  },

  // PROMOCIONES (9:30 a 12:00 p.m.)
  {
    id: 'promo-ceviche-qali-warma',
    name: 'Ceviche Qali Warma',
    description: 'Promoción (9:30 a 12:00 p.m.). Incluye vaso de chicha o maracuyá + queso helado.',
    price: 12.90,
    image: asset('ceviche.jpg'),
    category: 'promociones',
    ingredients: ['Ceviche']
  },
  {
    id: 'promo-ceviche',
    name: 'Ceviche (Promo)',
    description: 'Promoción (9:30 a 12:00 p.m.). Incluye vaso de chicha o maracuyá + queso helado.',
    price: 25.90,
    image: asset('ceviche.jpg'),
    category: 'promociones',
    ingredients: ['Ceviche']
  },
  {
    id: 'promo-cevichop',
    name: 'Cevichop (Promo)',
    description: 'Promoción (9:30 a 12:00 p.m.). Incluye vaso de chicha o maracuyá + queso helado.',
    price: 18.90,
    image: asset('ceviche.jpg'),
    category: 'promociones',
    ingredients: ['Cevichop']
  },
  {
    id: 'promo-ceviche-power',
    name: 'Ceviche Power (Promo)',
    description: 'Promoción (9:30 a 12:00 p.m.). Incluye vaso de chicha o maracuyá + queso helado.',
    price: 28.90,
    image: asset('mixto.jpg'),
    category: 'promociones',
    ingredients: ['Ceviche', 'Mariscos']
  },
  {
    id: 'promo-mostrito-triple',
    name: 'Mostrito Triple (Promo)',
    description: 'Promoción (9:30 a 12:00 p.m.). Incluye vaso de chicha o maracuyá + queso helado.',
    price: 38.90,
    image: asset('mixto.jpg'),
    category: 'promociones',
    ingredients: ['Ceviche', 'Arroz', 'Chicharrón']
  },

  // PORCIONES
  {
    id: 'porcion-arroz',
    name: 'Arroz',
    description: 'Porción de arroz.',
    price: 3.00,
    image: asset('arroz.jpg'),
    category: 'porciones',
    ingredients: ['Arroz']
  },
  {
    id: 'porcion-papa-frita',
    name: 'Papa frita',
    description: 'Porción de papa frita.',
    price: 5.00,
    image: asset('chop.jpeg'),
    category: 'porciones',
    ingredients: ['Papa']
  },
  {
    id: 'porcion-chicharron-pota',
    name: 'Chicharrón de pota',
    description: 'Porción de chicharrón de pota.',
    price: 7.00,
    image: asset('mixto.jpg'),
    category: 'porciones',
    ingredients: ['Pota']
  },
  {
    id: 'porcion-chicharron-pescado',
    name: 'Chicharrón de pescado',
    description: 'Porción de chicharrón de pescado.',
    price: 8.00,
    image: asset('mixto.jpg'),
    category: 'porciones',
    ingredients: ['Pescado']
  },
  {
    id: 'porcion-camote',
    name: 'Porción de camote',
    description: 'Porción de camote.',
    price: 3.00,
    image: asset('logo.png'),
    category: 'porciones',
    ingredients: ['Camote']
  },

  // POSTRES
  {
    id: 'queso-helado',
    name: 'Queso helado',
    description: 'Postre tradicional.',
    price: 10.00,
    image: asset('logo.png'),
    category: 'postres',
    ingredients: ['Queso helado']
  },

  // BEBIDAS (½ Lt / 1 Lt)
  {
    id: 'limonada',
    name: 'Limonada',
    description: '½ Lt / 1 Lt',
    price: 5.00,
    image: asset('logo.png'),
    category: 'bebidas',
    ingredients: ['Limón'],
    sizes: [
      { name: '½ Lt', price: 5.00 },
      { name: '1 Lt', price: 10.00 }
    ]
  },
  {
    id: 'limonada-hierbabuena',
    name: 'Limonada de hierba buena',
    description: '½ Lt / 1 Lt',
    price: 5.00,
    image: asset('logo.png'),
    category: 'bebidas',
    ingredients: ['Limón', 'Hierba buena'],
    sizes: [
      { name: '½ Lt', price: 5.00 },
      { name: '1 Lt', price: 10.00 }
    ]
  },
  {
    id: 'chicha-morada',
    name: 'Chicha morada',
    description: '½ Lt / 1 Lt',
    price: 6.00,
    image: asset('logo.png'),
    category: 'bebidas',
    ingredients: ['Maíz morado'],
    sizes: [
      { name: '½ Lt', price: 6.00 },
      { name: '1 Lt', price: 12.00 }
    ]
  },
  {
    id: 'maracuchicha',
    name: 'MaracuChicha',
    description: '½ Lt / 1 Lt',
    price: 6.00,
    image: asset('logo.png'),
    category: 'bebidas',
    ingredients: ['Maíz morado', 'Maracuyá'],
    sizes: [
      { name: '½ Lt', price: 6.00 },
      { name: '1 Lt', price: 12.00 }
    ]
  },
  {
    id: 'maracuya',
    name: 'Maracuyá',
    description: '½ Lt / 1 Lt',
    price: 5.00,
    image: asset('logo.png'),
    category: 'bebidas',
    ingredients: ['Maracuyá'],
    sizes: [
      { name: '½ Lt', price: 5.00 },
      { name: '1 Lt', price: 10.00 }
    ]
  },
  {
    id: 'limonada-frozen',
    name: 'Limonada frozen',
    description: '½ Lt / 1 Lt',
    price: 7.00,
    image: asset('logo.png'),
    category: 'bebidas',
    ingredients: ['Limón', 'Hielo'],
    sizes: [
      { name: '½ Lt', price: 7.00 },
      { name: '1 Lt', price: 12.00 }
    ]
  },

  // CERVEZAS
  {
    id: 'pilsen-670ml',
    name: 'Pilsen 670 ml',
    description: 'Cerveza.',
    price: 10.00,
    image: pilsenImg,
    category: 'cervezas',
    ingredients: ['Cerveza']
  },
  {
    id: 'cusquena-670ml',
    name: 'Cusqueña 670 ml',
    description: 'Cerveza.',
    price: 11.00,
    image: cusquenaImg,
    category: 'cervezas',
    ingredients: ['Cerveza']
  },
  {
    id: 'pacifico-360ml',
    name: 'Pacífico 360 ml',
    description: 'Cerveza.',
    price: 7.00,
    image: pacificoImg,
    category: 'cervezas',
    ingredients: ['Cerveza']
  },
  {
    id: 'corona-360ml',
    name: 'Corona 360 ml',
    description: 'Cerveza.',
    price: 8.00,
    image: coronaImg,
    category: 'cervezas',
    ingredients: ['Cerveza']
  },

  // CÓCTELES
  {
    id: 'pisco-sour',
    name: 'Pisco Sour',
    description: 'Cóctel.',
    price: 15.00,
    image: piscoSourImg,
    category: 'cocteles',
    ingredients: ['Pisco']
  },
  {
    id: 'maracuya-sour',
    name: 'Maracuyá Sour',
    description: 'Cóctel.',
    price: 18.00,
    image: asset('logo.png'),
    category: 'cocteles',
    ingredients: ['Maracuyá', 'Pisco']
  },
  {
    id: 'mojitos',
    name: 'Mojitos',
    description: 'Clásico, maracuyá, mango.',
    price: 18.00,
    image: mojitosImg,
    category: 'cocteles',
    ingredients: ['Ron', 'Hierba buena'],
    options: [
      {
        name: 'Sabor',
        choices: [
          { name: 'Clásico', price: 0 },
          { name: 'Maracuyá', price: 0 },
          { name: 'Mango', price: 0 }
        ]
      }
    ]
  },
  {
    id: 'cuba-libre',
    name: 'Cuba Libre',
    description: 'Cóctel.',
    price: 15.00,
    image: asset('logo.png'),
    category: 'cocteles',
    ingredients: ['Ron', 'Cola']
  },
  {
    id: 'sangria-hawaiana',
    name: 'Sangría hawaiana',
    description: 'Cóctel.',
    price: 25.00,
    image: asset('logo.png'),
    category: 'cocteles',
    ingredients: ['Vino']
  },
  {
    id: 'machu-picchu',
    name: 'Machu Picchu',
    description: 'Cóctel.',
    price: 14.00,
    image: asset('logo.png'),
    category: 'cocteles',
    ingredients: ['Licor']
  },
  {
    id: 'tequila-sunrise',
    name: 'Tequila Sunrise',
    description: 'Cóctel.',
    price: 14.00,
    image: asset('logo.png'),
    category: 'cocteles',
    ingredients: ['Tequila']
  },
  {
    id: 'mojito-con-corona',
    name: 'Mojito con Corona',
    description: 'Cóctel.',
    price: 14.00,
    image: asset('logo.png'),
    category: 'cocteles',
    ingredients: ['Mojito', 'Corona']
  },
  {
    id: 'margarita-corona',
    name: 'Margarita Corona',
    description: 'Cóctel.',
    price: 15.00,
    image: asset('logo.png'),
    category: 'cocteles',
    ingredients: ['Margarita', 'Corona']
  },
  {
    id: 'coronita-mango',
    name: 'Coronita de mango',
    description: 'Cóctel.',
    price: 15.00,
    image: asset('logo.png'),
    category: 'cocteles',
    ingredients: ['Mango', 'Corona']
  },
  {
    id: 'togarashi-cocktail',
    name: 'Togarashi Cocktail',
    description: 'Cóctel.',
    price: 12.00,
    image: togarashiImg,
    category: 'cocteles',
    ingredients: ['Cóctel']
  }
];

export const getProductsByCategory = (categoryId: string): Product[] => {
  return products.filter(product => product.category === categoryId);
};

export const getProductById = (id: string): Product | undefined => {
  return products.find(product => product.id === id);
};

export const getPopularProducts = (): Product[] => {
  return products.filter(product => product.popular === true);
};